var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnX = function SvgBtnX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.06 32.06 36 18 21.94 3.94 36 0 32.06 14.06 18 0 3.94 3.94 0 18 14.06 32.06 0 36 3.94 21.94 18 36 32.06Z",
    fill: "#fff"
  })));
};
export { SvgBtnX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9ImJ0bi14IiBkPSJNMzYgMzIuMDYwOEwzMi4wNjA4IDM2TDE4IDIxLjkzOTJMMy45MzkyMSAzNkwwIDMyLjA2MDhMMTQuMDYwOCAxOEwwIDMuOTM5MjFMMy45MzkyMSAwTDE4IDE0LjA2MDhMMzIuMDYwOCAwTDM2IDMuOTM5MjFMMjEuOTM5MiAxOEwzNiAzMi4wNjA4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";